import { useRef } from 'react';

/**
 * Returns the same array reference for as long as the keys are unchanged, so a
 * caller that rebuilds its list every render does not churn memo dependencies.
 * Keys are length-prefixed, so no separator can be mistaken for a boundary.
 */
export function useStableList<T>(items: T[], toKey: (item: T) => string): T[] {
  const key = items
    .map(item => {
      const itemKey = toKey(item);
      return `${itemKey.length}:${itemKey}`;
    })
    .join('');
  const cache = useRef({ key, items });

  if (cache.current.key !== key) {
    cache.current = { key, items };
  }

  return cache.current.items;
}
